import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import DashBoardNav from "./components/DashBoardNav";
import DashBoardSideNav from "./components/DashBoardSideNav";
import Notification from "./components/Notification";
interface DashboardLayoutProps {
}


const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
    const [currentPage, setCurrentpage] = useState<string>('home');
    useEffect(() => {
        console.log(currentPage);
    }, [currentPage])
    const [navVisibility, setNavVisibility] = useState<boolean>(false);
    useEffect(() => {
        console.log(window.innerWidth);
        if (window.innerWidth > 900) {
            setNavVisibility(true)
        }
    }, [window.visualViewport?.width])


    return (
        <>
            <div className="dashboard-body">
                {
                    navVisibility ? (
                        <>
                            <DashBoardNav />
                        </>
                    ) : (
                        <>
                        </>
                    )
                }
                <DashBoardSideNav />
                {<Notification messages={[]}/>}
                <main>
                    <Outlet />
                </main>
                <Footer />
            </div>
        </>

    );
};

export default DashboardLayout;
